import { COLORS } from '../../theme/variables';

export const actionIcon = () => ({
  cursor: 'pointer',
  color: COLORS.COLOR_GRAY_PLACEHOLDER
});
